import { BActionIcon } from '@components/BActionIcon/BActionIcon';
import { GlobalOverlay } from '@components/index';
import { Popover } from '@mantine/core';
import { useState } from 'react';
import { UpdatesMenuDropdown } from './NoFeatureMenu.styles';
import { NoFeatureMenuContent } from './NoFeatureMenuContent';

export function NoFeatureMenu() {
  const [value, setValue] = useState(false);
  return (
    <>
      {value && <GlobalOverlay />}
      <Popover opened={value} onChange={setValue} position="bottom-end">
        <Popover.Target>
          <BActionIcon icon="more" onClick={() => setValue(true)} />
        </Popover.Target>
        <UpdatesMenuDropdown>
          <NoFeatureMenuContent close={() => setValue(false)} />
        </UpdatesMenuDropdown>
      </Popover>
    </>
  );
}
